// eslint-disable-next-line no-unused-vars
const AppUI = (function () {
    let currentTemplate;
    let currentGamesCategory;
    let appData;
    let mobileGameCategory;
    let mobileSingelGame;
    let MobilePartialsRequestCategory;
    let MobilePartialsRequestGame;

    let ynaHeader;
    let ynaSearchForm;
    let ynaMobileHomePage;
    let ynaGameFilters;
    let ynaHomeBanners;
    let ynaWinnersTicker;
    let ynaGamesGrid;
    let isGamesReady = false;
    let gamesOpened;
    let themeURI;
    const dictionaryRequest = $.Deferred();
    const $loadMoreBtn = $('.more-games-button');
    const LOAD_BY_SCROLL = 3;
    let loadMore = 0;
    let sortedCategoriesMap = false; // Map of game categories
    let subcategory = 0;
    let sortClicked = false; // Flag that marks if path was 'subCategory' click or 'gamesSort' click
    let sortGameStatus = false;
    const $gamesSort = $('.games-sort');
    const $bonusBalanceMessage = $('.bonus-balance-popup-wrap');

    let fistTimeStartSlickSliderRun = true;

    const init = function (mainGamesCategory, pageTemplate, data) {
        hideLoader();

        if (Cookie.read('CookiePolicy')) {
            $('body').addClass('cookiePolicyRead');
        }

        if (Player.isRegistered()) {
            $('body').addClass('isRegistered');
        }

        appData = data || {};
        currentTemplate = pageTemplate;
        addHomePageClass();
        setNewGamePageClass();
        themeURI = AsgApp.getThemeUri();

        /**
         * send lobby_open event if on game page or sport page
         */
        AsgUI.fireTriggerIfIsGamePageOrSportPage(pageTemplate);

        setMobileClass();
        setYnaComponents();
        if (!Cookie.read('lobbyMode')) {
            ynaHeader.initStickHeader();
            setNewUsersMode();
        }

        initUiElements();

        if (AsgFW.isMobilePamPlatform()) {
            if (AsgApp.isGamePageTemplate()) {
                setNewGamePagePreferences();
            }

            if (isHomeTemplate()) {
                ynaMobileHomePage.toggleMobileMode();
                ynaMobileHomePage.initScrollLazyload();
                ynaHeader.initStickHeader();
            }
            loadMobilePartialsCategory();
            loadMobilePartialsGame();

            let lastScroll = 0;

            $(window).on('scroll', function () {
                const st = $(this).scrollTop();
                const $stickyFooter = $('.sticky-footer');
                const $body = $('body');

                if (st > 140 && st > lastScroll) {
                    $stickyFooter.addClass('footer-with-navbar-height');
                    $body.addClass('scroll-down');
                } else {
                    $stickyFooter.removeClass('footer-with-navbar-height');
                    $body.removeClass('scroll-down');
                }
                lastScroll = st;
            });
        } else {
            if ($loadMoreBtn.length) {
                $(window).on('scroll', function () {
                    // Auto click on "load more" (games) button
                    if (isInView($loadMoreBtn) && loadMore < LOAD_BY_SCROLL) {
                        loadMore += 1;
                        $loadMoreBtn.trigger('click');
                    } else if (loadMore >= LOAD_BY_SCROLL) {
                        $loadMoreBtn.removeClass('invisible');
                    }
                });
            }

            // For pages without Games search (they have own shrinking) and Lobby page
            if ($('.games-categories-search-section').length === 0
                || $('.games-categories-search-section').is(':hidden')
            ) {
                $(window).on('scroll resize', function () {
                    const scrollHeightForShrink = 478;
                    const mobileBannerScroll = 124;
                    const scrollTop = $(this).scrollTop();

                    if (
                        scrollTop > scrollHeightForShrink
                        || (isSmallDevice() && scrollTop > mobileBannerScroll)
                    ) {
                        $('#site-header').addClass('is-shrinked');
                    } else {
                        $('#site-header').removeClass('is-shrinked');
                    }
                });
            }
        }

        $(document).on('asgReady', function () {
            // management if display the cookie policy
            setCookiePolicyEvent();

            // add fun fix info page view
            const borderCell = $('.StandardPageLeftSectionContentBottomBorderCell');
            if (borderCell.length) {
                borderCell.remove();
            }
            ynaHeader.initStickHeader();
            setHomePageUi();

            /**
             * send lobby_open event if on game page or sport page
             */
            AsgUI.fireTriggerIfIsGamePageOrSportPage(pageTemplate);
            AsgUI.initBannersCarousel(true);
        });

        $(document).on('bannersReady', function () {
            if (isHomeTemplate()) {
                // insert Game banner data
                setGameBanner();

                // insert Main banner data
                setMainBanners();

                if (AsgFW.isMobilePamPlatform()) {
                    $('.games-categories-search-section [data-slick-index="0"]').trigger('click').addClass('active');
                }

                ynaGameFilters.sliderOnMobile();
                ynaGameFilters.addHeaderMargin();

                if (isLobbyMode()) {
                    ynaHomeBanners.activateImageMode();
                } else {
                    ynaHomeBanners.deactivateImageMode();
                }
                if (window.Yna.WebApp.isMobile()) {
                    ynaHomeBanners.moveToTop();
                }
            }

            const getSubCategoryFromUrl = Tools.getParameters(Tools.getNavUrl());
            if (Object.prototype.hasOwnProperty.call(getSubCategoryFromUrl, 'sub-category')) {
                $(`#sub-${getSubCategoryFromUrl['sub-category']}`).trigger('click');
            }
            AsgApp.setActionEvents('#banners');

            setMobileDkRegulationText();
            if (!$('#home-banner .regulation-txt').length && !AsgFW.isMobilePamPlatform()) {
                if ($('.regulation-txt').length) {
                    $('#home-banner').prepend($('.regulation-txt')[0].outerHTML);
                    AsgApp.setRegulationTerms();
                }
            }
        });

        const onPlayButtonClick = (e) => {
            e.stopPropagation();
            if (e.currentTarget.dataset.btnAction) {
                switch (e.data.buttonType) {
                case 'promotion':
                    AsgApp.execPromotionCTA(e.currentTarget.dataset);
                    break;
                default:
                    AsgApp.execBtnAction(e.currentTarget.dataset);
                }
            } else {
                AsgApp.playNow();
            }
        };
        $('.main').on(
            'click',
            '.playnow-button-link[data-name="promotion-cta-button"]',
            { buttonType: 'promotion' },
            onPlayButtonClick,
        );

        $('.main').on(
            'click',
            '.playnow-button-link:not([data-name="promotion-cta-button"]), .playnow-button:not([data-name="promotion-cta-button"])',
            {},
            onPlayButtonClick,
        );

        $gamesSort.on('click', function () {
            const category = parseInt(findActiveGameCategory(), 10);
            const sortReverse = !!sortedCategoriesMap[category][subcategory];
            sortClicked = true;

            Games.sortGames(sortReverse, category, subcategory);
            $('.game-item.default-game').remove();
            sortedCategoriesMap[category][subcategory] = !sortReverse;
            sortStateUpdate(sortedCategoriesMap[category][subcategory], $gamesSort);

            sortGameStatus = !sortGameStatus;
            const GAcategory = 'Main Screen';
            const GAaction = (sortGameStatus) ? 'Sort A/Z' : 'Sort Z/A';
            const GAlabel = (Player.isLoggedIn()) ? 'Click sort post login' : 'Click sort pre login';
            AsgApp.GAeventTracking(GAcategory, GAaction, GAlabel);

            $(document).trigger('gamesReady');
        });

        const setMobileDkRegulationText = function () {
            if (AsgFW.isMobilePamPlatform() && AsgApp.isBrandDK()) {
                const dkRegulationText = $('#mobile-dk-regulation-text').data('regulation');
                const seeMore = (Player.isLoggedIn()) ? Dictionary.translate('RegulationTermsPostLogin') : Dictionary.translate('RegulationTermsPreLogin');
                $('#mobile-dk-regulation-text').html(`<div class="mobile-dk-regulation-text primary-bgcolor"><a href="/promotions/welcome-package/">${dkRegulationText}<span class="see-more-link">${seeMore}</span></a></div>`);
                $('#mobile-dk-regulation-text').next('.regulation-txt').hide();
            }
        };

        // On gamesReady event inside the asgReady event.
        $(document).on('gamesReady', function () {
            Games.liveCasinoStart();

            setGameLinkByIdOnLobbyPage();

            isGamesReady = true;
            const categories = Games.getCategories();
            const activeFlag = $('.games-categories li > .active');
            if (activeFlag.length > 0) {
                // eslint-disable-next-line no-param-reassign
                mainGamesCategory = parseInt(activeFlag.attr('class').replace('game-category-', '').replace(' active', ''), 10);
            }

            if (!sortedCategoriesMap) {
                initGameCategoriesMapping();
            }

            if (!AsgFW.isMobilePamPlatform() && $('.lobby-home').data('category') && $('.lobby-home').data('category') >= 0) {
                // eslint-disable-next-line no-param-reassign
                mainGamesCategory = $('.lobby-home').data('category');
            }

            // Which category are selected
            currentGamesCategory = findActiveGameCategory(mainGamesCategory);

            // build categories html
            setGamesCategories();

            // build sub categories html
            setGamesSubCategories(currentGamesCategory);

            if (currentTemplate !== 'template-home.php' && currentTemplate !== 'template-lobby.php') {
                $('.games-categories-search-section').hide();
            }
            if (currentTemplate === 'sitemap.php') {
                $('.games-categories-search-section').show().addClass('is-fixed');
            }

            // display selected category and SubCategories that match
            gamesCategoriesOnClick();

            // display selected SubCategories
            gamesSubCategoriesOnClick();

            setCategoriesAsync(categories)
                .then(() => setTickerDataAsync())
                .then(() => initGamesReady())
                .then(() => (new Promise(resolve => {
                    setTimeout(() => {
                        loadImages();
                        resolve();
                    }, 50);
                })))
                .then(() => loadMarketingScripsAsync());

            // Additional 'LoogedIn' event handler after 'gamesReady' event
            // to process only login event itself and skip every page load.
            $(document).on('LoggedIn', function () {
                if (isGamePage()) {
                    openPostLoginGame(data.gameName);
                }
                AsgUI.toggleGAEvents();
            });

            // Additional 'LoogedOut' event handler after 'gamesReady' event
            // to process only logout event itself and skip every page load.
            $(document).on('LoggedOut', function () {
                if (isGamePage()) {
                    if (!AsgFW.isMobilePamPlatform()) {
                        loadGameInPage(appData.gameName, 'D'); // Switch game to Demo mode after login out.
                    } else {
                        $('.game-page-load-game').off('click');
                        $(document).on('click', '.game-page-load-game', function () {
                            AsgApp.loadGame(`${$(this).data('actionInfo').split('|')[0]}|D`);
                        });
                    }
                }
                AsgUI.toggleGAEvents();
            });
        });

        // Relevant for mobile. Triggered after a category
        // "view all" is clicked, and view is rebuilt
        $(document).on('singleCategoryContainerLoaded', function () {
            // Specific fix to hide sorting for Recent games in mobile
            try {
                if ($('.mobile-single-category-grid .mobile-category-title')[0].childNodes[0].nodeValue.trim() === Games.recentGamesName()) {
                    $('.mobile-single-category-grid .games-sort').hide();
                } else {
                    $('.mobile-single-category-grid .games-sort').show();
                }
            } catch (e) {
                Tools.error('Games category render failed', e);
            }

            if (window.AsgSharedComponents) {
                window.AsgSharedComponents.renderJackpots();
            }

            $('.games-sort-mobile').on('click', function () {
                const isReverse = this.dataset.sorted === 'top';
                const $gamesGrid = $('.mobile-single-category-games-grid');
                let games = $gamesGrid.find('.game-item');

                games = sortGamesMobile(games, isReverse);
                $gamesGrid.html(games);

                if (isReverse) {
                    this.dataset.sorted = 'bottom';
                } else {
                    this.dataset.sorted = 'top';
                }

                sortStateUpdate(!isReverse, $(this));
            });
        });

        const sortGamesMobile = function (games, isReverse) {
            if (isReverse) {
                games.sort((a, b) => {
                    const firstGameName = a.dataset.gameName.trim().toLowerCase();
                    const secondGameName = b.dataset.gameName.trim().toLowerCase();

                    return firstGameName > secondGameName ? -1 : 1;
                });
            } else {
                games.sort((a, b) => {
                    const firstGameName = a.dataset.gameName.trim().toLowerCase();
                    const secondGameName = b.dataset.gameName.trim().toLowerCase();

                    return firstGameName > secondGameName ? 1 : -1;
                });
            }
            return games;
        };

        $(document).on('endInGame', function () {
            stopGameMode();
            $('body').removeClass('start-in-game');
            setTimeout(function () {
                const headerHeight = $('.navbar.navbar-inverse.new-header').height();
                $('#app > .wrap').css({ 'padding-top': `${headerHeight}px` });
            }, 100);
        });

        $(document).on('startInGame', function (event) {
            startGameMode();
            $('body').addClass('start-in-game');

            if (
                AsgApp.getDisplayBalance().BonusBalance > 0
                && !AsgFW.isMobilePamPlatform()
                && InGame.getGameMode() === 'M'
                && (
                    AsgFW.getPlayerRegulationType() === '-'
                    || AsgFW.getPlayerRegulationType() === 'GB'
                )
            ) {
                $bonusBalanceMessage.addClass('show-bonus-balance-popup');
                setTimeout(() => {
                    $bonusBalanceMessage.removeClass('show-bonus-balance-popup');
                }, AsgApp.getBonusMessageTimeout());
            } else {
                $bonusBalanceMessage.removeClass('show-bonus-balance-popup');
            }
            $(window).trigger('resize');

            if (AsgFW.isMobilePamPlatform()) {
                const body = document.getElementsByTagName('body')[0];
                body.classList.remove('netent-game');
                if (
                    Player.isLoggedIn()
                    && Games.isNetEntGame(event.detail.gameId)
                    && event.detail.playMode === 'M'
                ) {
                    body.classList.add('netent-game');
                    Games.gameImprovementsRender();
                }
            } else {
                Games.gameImprovementsRender();
            }
        });

        $(document).on('LoggedOut', function () {
            $('body').addClass('LoggedOut');
            $('body').removeClass('LoggedIn');
            if (isLobbyMode()) {
                setLobbyMode();
                hideFromLobby();
            }
            setWpInnerSideBanner();
            window.Yna.asgApp.changeAuthState('logged_out');
            ynaHeader.changeAuthState('logged_out');
            setPlayerLobbyBanners();
        });

        $(document).on('LoggedIn', function () {
            setDisplayBalance();
            setLoyaltyPoints();
            $('body').addClass('LoggedIn').addClass('isRegistered').removeClass('LoggedOut');
            setWpInnerSideBanner();
            menuTitleUpdate();
            setLobbyMode();
            window.Yna.asgApp.changeAuthState('logged_in');
            ynaHeader.changeAuthState('logged_in');
            ynaHeader.hideLoggedInMenuItems();
            setPlayerLobbyBanners();
        });

        $(document).on('LoggedIn endInGame', function () {
            $(document).one('recentGamesUpdated', function () {
                if (AsgFW.isMobilePamPlatform()) {
                    const categories = Games.getCategories();
                    const position = AsgApp.isGermanyBuyWinActive() ? 1 : 0;
                    const recents = categories.filter(function (el) {
                        return el.name === Games.recentGamesName();
                    });

                    if (
                        recents.length === 1
                        && categories[categories.length - 1].name === Games.recentGamesName()
                    ) {
                        // Put Recent games in mobile on the first or second position.
                        categories.splice(position, 0, categories.pop());
                    // eslint-disable-next-line max-len
                    } else if (categories[position].name === categories[categories.length - 1].name) {
                        // Put Recent games in mobile on the first or second position.
                        categories.splice(position, 1, categories.pop());
                    }

                    setTimeout(function () {
                        const mobileGrid = $('#mobile-categories-grid');
                        mobileGrid.hide();
                        mobileCategoryGrid(categories);
                        ynaMobileHomePage.hideCategoryPage();
                    }, 3000);
                }
            });
        });

        $(document).on('justLoggedOut', function () {
            $(document).one('gameUpdateFinished', function () {
                if (isHomeTemplate() && isLobbyMode()) {
                    const categories = Games.getCategories();
                    if (AsgFW.isMobilePamPlatform()) {
                        setTimeout(function () {
                            $('#mobile-categories-grid').hide();
                            mobileCategoryGrid(categories);
                            $('#mobile-categories-grid').show();
                        }, 3000);
                    }
                }
            });
        });

        $(document).on('justLoggedIn justLoggedOut', function () {
            $(document).one('gameUpdateFinished', function () {
                if (isHomeTemplate() && isLobbyMode()) {
                    initGameCategoriesMapping();
                }
            });
        });

        $(document).on('balanceUpdated', function () {
            setDisplayBalance();
            triggerShooter('balanceUpdated');
        });

        $(document).on('depositSucceeded', function () {
            setDisplayBalance();
            triggerShooter('balanceUpdated');
        });

        $('#bunners').on('click', '.regulation-txt', function (event) {
            event.stopPropagation();
        });

        $('.home-games-grid-section').on('click', '.regulation-txt', function (event) {
            event.stopPropagation();
        });

        $('.container-fluid, .is-input-group .close').on('click', function () {
            Yna.asgApp.components.searchForm.hideForm();
            $('.main-menu-mobile').show(); // shows the upper menu back when the search form closes
        });

        Tools.fixAnchorAnimate();
        closeSideMenu();

        // DK promotions short terms link scroll to full T&C
        if (currentTemplate === 'info.php' && $('.dk-short-terms').length > 0) {
            $('.dk-terms-seemore a').on('click', function (e) {
                e.preventDefault();
                const topmenuoffset = AsgFW.isMobilePamPlatform() ? 80 : 100;
                $('html').animate({ scrollTop: $('.terms-row').offset().top - topmenuoffset }, 'fast');
            });
        }

        $(document).on('showGameSearch', function () {
            addRecentlyPlayedGamesToGrid();
        });

        $('.search-game-label').on('click', function () {
            $(document).trigger('showGameSearch');
        });

        $(document).on('verticalsReady', () => {
            AsgUI.NewHeader.init3Y();
        });
    }; // end AppUI.init()

    const hideLoader = () => {
        // don't stop loader immediately for promotions page and new flag
        if (AsgApp.isLtPromotionsEnabled()) {
            if (!AsgApp.isPromotionsPage()) {
                window.Yna.asgApp.stopLoading();
            }
        } else {
            window.Yna.asgApp.stopLoading();
        }

        // for lt promotions flag - wait for data before hide loader on /promotions
        if (AsgApp.isLtPromotionsEnabled() && AsgApp.isPromotionsPage()) {
            Promise.race([
                Tools.timeoutAfter(5),
                new Promise((resolve) => {
                    document.addEventListener('asgLtPromotionsReady', () => {
                        resolve();
                    }, { once: true });
                }),
            ])
                .then(window.Yna.asgApp.stopLoading)
                .catch(window.Yna.asgApp.stopLoading);
        }
    };

    const setCategoriesAsync = function (categories) {
        return new Promise(resolve => {
            setTimeout(() => {
                // check if relevant
                if (AsgFW.isMobilePamPlatform()) {
                    mobileCategoryGrid(categories);
                    Games.liveCasinoRefresh();
                    $('.more-link').click(() => {
                        setTimeout(() => {
                            Games.liveCasinoRefresh();
                        }, 10);
                    });
                } else if (isLobbyMode()) {
                    $(`.game-category-${currentGamesCategory}`).trigger('click');
                } else {
                    const $gamesGrid = $('#games-grid .game-name[data-game-name-by-id]');
                    $.each($gamesGrid, function () {
                        const gid = $(this).data().gameNameById;
                        try {
                            $(this).text(Games.getGameNameById(gid));
                        } catch (e) {
                            console.error(e);
                        }
                    });
                }

                resolve();
            }, 50);
        });
    };

    const setTickerDataAsync = function () {
        return new Promise(resolve => {
            setTimeout(() => {
                setTickerGamesData();

                if (AsgFW.isMobilePamPlatform() && AsgFW.getRbcSettings('showWinnerTicker')) {
                    const tickerCount = $('.mobile-winner-ticker-wrap .winners-ticker-item').length;
                    $('.ticker-skeleton').remove();
                    if (tickerCount <= 1) {
                        $('.mobile-winner-ticker-wrap').show();
                        $('.mobile-winner-ticker-wrap').addClass('oneWinners');
                    } else if (tickerCount === 2) {
                        $('.mobile-winner-ticker-wrap').show();
                        $('.mobile-winner-ticker-wrap').addClass('twoWinners');
                    } else if (tickerCount === 3) {
                        $('.mobile-winner-ticker-wrap').show();
                        $('.mobile-winner-ticker-wrap').addClass('ticketWithOutCarousel');
                    } else {
                        $('.mobile-winner-ticker-wrap').show();
                        setTimeout(() => {
                            mobileWinnerTickerInit();
                            AsgApp.setActionEvents('.winners-ticker-item');
                        }, 5000);
                    }
                }

                setTimeout(() => {
                    if (fistTimeStartSlickSliderRun) {
                        fistTimeStartSlickSliderRun = false;
                        ynaWinnersTicker.startSlickSlider();
                    }
                    AsgApp.setActionEvents('.play-game-btn, .item-holder');
                }, 500);

                resolve();
            }, 50);
        });
    };

    const initGamesReady = function () {
        return new Promise(resolve => {
            moreGame(); /* add more games to the grid */
            gamesSearchInit(); /* show search result */

            const isIsotopeSet = Yna.asgApp.components.gamesGrid.$grid !== null;
            if (!AsgFW.isMobilePamPlatform() && isIsotopeSet) {
                ynaGamesGrid.refreshGrid();
            }
            AsgApp.setActionEvents('.winners-ticker-list .winners-ticker-item');
            specialBenefits();/* set the accordion in vip page */
            ynaMobileHomePage.toggleMobileMode();
            if (AsgFW.isMobilePamPlatform()) {
                const mobCategory = $('.lobby-home').data('mobcategory');
                if (mobCategory && mobCategory >= 0) {
                    $('#mobile-app-canvas').css('visibility', 'hidden');
                    setTimeout(
                        function () {
                            const cat = $(`#mobile-categories-grid div:nth-child(${mobCategory})`);
                            const link = cat.find('.more-link');
                            link.trigger('click');
                            $('#mobile-app-canvas').css('visibility', 'inherit');
                        }, 0,
                    );
                }
            }

            processDirectGamePageLoad(appData.gameName);
            processPostLoginPageOpen();
            if (isHomeTemplate()) {
                showGameNotAvailableNotification();
            }

            resolve();
        });
    };

    const processDirectGamePageLoad = (gameName) => {
        const openGame = (name, mode) => {
            if (!AsgFW.isMobilePamPlatform()) {
                loadGameInPage(name, mode);
            } else if (AsgFW.isMobilePamPlatform()) {
                setGameIdInPage(name, mode);
            }
        };

        if (isGamePage()) {
            // no direct game pages for logged in
            if (Player.isLoggedIn()) {
                return AsgApp.redirectToLobby();
            }

            const withNotification = true;
            AsgApp.redirectPageGameIfGameNotExist(gameName, withNotification);
            openGame(gameName, 'D');
        }
    };

    const processPostLoginPageOpen = () => {
        if (AsgFW.isLoggedIn() && isHomeTemplate()) {
            const gameName = Cookie.read(AsgApp.cookieNames.OPEN_POST_LOGIN_GAME_PAGE);
            Cookie.remove(AsgApp.cookieNames.OPEN_POST_LOGIN_GAME_PAGE, '/');
            if (!gameName) {
                return;
            }

            loadGameInPage(gameName, 'M');
        }
    };

    const openPostLoginGame = (gameName) => {
        Cookie.create(AsgApp.cookieNames.OPEN_POST_LOGIN_GAME_PAGE, gameName, '180', '/');
        AsgApp.redirectToLobby();
    };

    const showGameNotAvailableNotification = () => {
        if (
            Cookie.read(AsgApp.cookieNames.GAME_NOT_AVAILABLE_NOTIFICATION)
            && GameNotAvailableMessage
        ) {
            GameNotAvailableMessage.show();
            Cookie.remove(AsgApp.cookieNames.GAME_NOT_AVAILABLE_NOTIFICATION, '/');
        }
    };

    const loadMarketingScripsAsync = function () {
        return new Promise((resolve) => {
            setTimeout(function () {
                AsgApp.loadChatProvider();
            }, 5000);

            resolve();
        });
    };

    const addRecentlyPlayedGamesToGrid = function () {
        const recentTitle = $('.recent');
        const gamesList = $('.games-list');
        const rgl = JSON.parse(Cookie.read('recentGamesList'));
        let gameSearchHtml;
        if (rgl != null) {
            recentTitle.show();
            gamesList.empty();
            rgl.forEach(function (recentlyPlayedGame) {
                const game = Games.getGameById(recentlyPlayedGame);
                gameSearchHtml = Games.generateGameItem(game.id, game.name, game.images.default, game.images.webp, false, false, false, true, '', '', '', game.externalGameProvider, game.externalGameSubProvider);
                gameSearchHtml = AsgUI.filterDemoButtons(gameSearchHtml, game);
                gamesList.show();
                gamesList.append(gameSearchHtml);
            });
            replaceSearchImage();
            AsgApp.setActionEvents('.search-game');
        }
    };

    const initGameCategoriesMapping = function () {
        sortedCategoriesMap = Games.getCategories()
            .map(category => category)
            .map(sub => sub.subCategories.map(() => undefined));
        sortStateUpdate(undefined, $gamesSort);
    };

    const sortStateUpdate = function (state, $sortButtonElem) {
        if (state !== undefined) {
            $sortButtonElem.addClass('active');
        } else {
            $sortButtonElem.removeClass('active');
            $sortButtonElem.find('.arrow').hide();
            return;
        }

        if (state) {
            $sortButtonElem.find('.arrow-down').hide();
            $sortButtonElem.find('.arrow-up').show();
        } else {
            $sortButtonElem.find('.arrow-down').show();
            $sortButtonElem.find('.arrow-up').hide();
        }
    };

    const hasWpSpecialEvent = function () {
        return Object.prototype.hasOwnProperty.call(appData, 'specialEventPreLoginWpLink')
            && Object.prototype.hasOwnProperty.call(appData.specialEventPreLoginWpLink, 'wp_special_event_banner')
            && appData.specialEventPreLoginWpLink.wp_special_event_banner !== '';
    };

    const hasWpInnerSideBanner = function () {
        return Object.prototype.hasOwnProperty.call(appData, 'specialEventPreLoginWpLink')
            && Object.prototype.hasOwnProperty.call(appData.specialEventPreLoginWpLink, 'wp_special_event_inner_side_banner')
            && appData.specialEventPreLoginWpLink.wp_special_event_inner_side_banner !== '';
    };

    const setWpInnerSideBanner = function () {
        const wpBannerSpecialElement = $('.inner-sidebanner img');

        wpBannerSpecialElement.removeAttr('data-action');
        wpBannerSpecialElement.removeAttr('data-action-info');

        if (!Player.isLoggedIn() && hasWpInnerSideBanner()) {
            const banner = {
                LinkType: 'E',
                TargetURL: appData.specialEventPreLoginWpLink.wp_special_event_inner_side_banner,
            };
            AsgApp.getbannerLinkType(banner, wpBannerSpecialElement);
            AsgApp.setActionEvents('.inner-sidebanner');
        } else {
            $('.bunner-inner-page').data('action', 'showDeposit');
            AsgApp.getbannerLinkType(' ', wpBannerSpecialElement);
            AsgApp.setActionEvents('.inner-sidebanner');
        }
    };

    const setPlayerLobbyBanners = function () {
        const bannerSpecialElement = $('.big-game .game-image');
        bannerSpecialElement.removeAttr('data-action');
        bannerSpecialElement.removeAttr('data-action-info');
        bannerSpecialElement.off('click.asgApp');
        let banner;

        if (Player.isLoggedIn()) {
            const bannerSpecial = AsgApp.getBannersSpecial();
            if (bannerSpecial != null) {
                banner = $('.big-game');
                banner.attr('src', bannerSpecial.Source);
                AsgApp.getbannerLinkType(bannerSpecial, banner);
            }
        } else if (hasWpSpecialEvent()) {
            const wpBannerSpecialElement = $('.big-game .game-image');
            banner = {
                LinkType: 'E',
                TargetURL: appData.specialEventPreLoginWpLink.wp_special_event_banner,
            };
            AsgApp.getbannerLinkType(banner, wpBannerSpecialElement);
        } else {
            AsgApp.getbannerLinkType('', bannerSpecialElement);
        }
        AsgApp.setActionEvents('#games-grid');
    };

    const addHomePageClass = function () {
        if (isHomeTemplate()) {
            $('body').addClass('lobby');
        }
    };

    const isHomeTemplate = function () {
        return currentTemplate === 'template-home.php' || currentTemplate === 'template-lobby.php';
    };

    const setYnaComponents = function () {
        ynaHeader = window.Yna.asgApp.components.header;
        ynaSearchForm = window.Yna.asgApp.components.searchForm;
        ynaMobileHomePage = window.Yna.asgApp.components.mobileHomePage;
        ynaGameFilters = window.Yna.asgApp.components.gameFilters;
        ynaHomeBanners = window.Yna.asgApp.components.homeBanners;
        ynaWinnersTicker = window.Yna.asgApp.components.winnersTicker;
        ynaGamesGrid = window.Yna.asgApp.components.gamesGrid;
    };

    const initUiElements = function () {
        ynaHeader.initMenuManager();
        ynaHeader.initStickHeader();

        ynaSearchForm.$headerContainer = window.Yna.asgApp.component('header').$container;
        ynaSearchForm.$searchField.on('focus', ynaSearchForm.showForm.bind(ynaSearchForm));
        // ynaSearchForm.$searchField.on('blur', ynaSearchForm.hideForm.bind(ynaSearchForm));
        ynaSearchForm.$searchField.on('input', ynaSearchForm.showHideResults.bind(ynaSearchForm));
        ynaSearchForm.showHideResults();

        setTimeout(() => {
            ynaWinnersTicker.setTickerClasses();
        }, 5000);
    };

    const isSmallDevice = function () {
        return window.innerWidth < 1025;
    };

    const setMobileClass = function () {
        if (AsgFW.isMobilePamPlatform()) {
            $('body').addClass('is-mobile');
        } else {
            $('body').removeClass('is-mobile');
        }
    };

    const setNewGamePageClass = function () {
        if (AsgFW.isMobilePamPlatform() && isGamePage()) {
            $('body').addClass('new-game-page-active');
        }
    };

    const setLobbyMode = function () {
        if (isHomeTemplate()) {
            $('body').addClass('is-lobby-mode');
            $('#app').removeClass('boxed');
            ynaGamesGrid.unsetPreLoginGames();
            if (!window.Yna.WebApp.isMobile()) {
                ynaHomeBanners.moveToTop();
                if (isGamesReady) {
                    $(document).one('gameUpdateFinished', function () {
                        $(document).trigger('gamesReady');
                    });
                }
            }

            $('.games-categories-search-section').show();
            hideFromLobby();
            Cookie.create('lobbyMode', 1, '180');
        }
    };

    const setNewUsersMode = function () {
        if (isHomeTemplate()) {
            ynaGamesGrid.setPreLoginGames();
            if (!AsgFW.isMobilePamPlatform()) {
                ynaHomeBanners.moveToHomeRow();
            }
            ynaWinnersTicker.moveToHomeRow();
            $('.games-categories-search-section').hide();
        }
    };

    const setHomePageUi = function () {
        if (isLobbyMode()) {
            setLobbyMode();
        } else {
            setNewUsersMode();
        }
    };

    const isLobbyMode = function () {
        return Player.isLoggedIn() || Cookie.read('lobbyMode') || AsgFW.getRbcSettings('t3FirstVisit');
    };

    const hideFromLobby = function () {
        $('.hide-from-lobby').hide();
    };

    const triggerShooter = function (triggerToShot) {
        $('#app').trigger(triggerToShot);
    };

    const setCookiePolicyEvent = function () {
        if (!AsgApp.getIsNativeApp()) {
            $(document).on('showCookiePopup', function () {
                $('.cockie-popup-wrap').addClass('show-cookie-popup');
            });

            $('.cockie-popup-close').on('click', function () {
                $('.cockie-popup-wrap').removeClass('show-cookie-popup');
                Cookie.create('CookiePolicy', 1, '180', '/');
                $('body').addClass('cookiePolicyRead');
            });
        }
    };

    const findActiveGameCategory = function (mainGamesCategory) {
        const categories = Games.getCategories();
        const activeFlag = $('.games-categories li > .active');
        let categoryText = '';

        if (activeFlag.length > 0) {
            categoryText = $(activeFlag[0]).text().toUpperCase();
        } else {
            return mainGamesCategory !== -1 ? mainGamesCategory : Games.getDefaultCategory();
        }

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < categories.length; i++) {
            if (categories[i].name.toUpperCase() === categoryText.trim()) {
                return i;
            }
        }
        return Games.getDefaultCategory();
    };

    const setGamesCategories = function () {
        let html = '';
        const categories = Games.getCategories();
        let i = 0;
        categories.forEach(function (cat) {
            html += Games.generateCategoryItem(cat.name, i, currentTemplate);
            i += 1;
        });
        $('.mobile-games-categories-grid.preload').remove();
        $('.games-categories').html(html);
    };

    const generateSubCatImageName = function (category, subCat, order) {
        if (AsgApp.isGermanyBuyWinActive() && category === 0) {
            return (subCat.codeName === 'buyWin') ? 'buy-win-icon' : `${currentGamesCategory}_${order - 1}`;
        }
        return `${currentGamesCategory}_${order}`;
    };

    const setGamesSubCategories = function (category) {
        let html = '';
        let subCategories;
        // eslint-disable-next-line no-param-reassign
        category = category || 0;
        try {
            subCategories = Games.getSubCategories(category);
        } catch (e) {
            subCategories = Games.getSubCategories(0);
        }
        subCategories = Games.addRecentGamesSubCategories(subCategories, -1);

        let i = 0;

        if (AsgFW.isMobilePamPlatform()) {
            const categories = Games.getCategories();
            categories.forEach(function (cat) {
                html += Games.generateCategoryItem(
                    cat.name,
                    i,
                    getOldHomeTemplate(currentTemplate),
                );
                i += 1;
            });
        } else {
            subCategories.forEach(function (subCat) {
                html += Games.generateSubCategoryItemByCategory(
                    subCat.name,
                    i,
                    generateSubCatImageName(category, subCat, i),
                    category,
                    subCat.extraElement,
                );
                i += 1;
            });
        }
        $('.games-menu-list').html(html);
    };

    const gamesCategoriesOnClick = function () {
        $('.games-categories li a').on('click', function (evt) {
            if (isHomeTemplate()) {
                if (!isLobbyMode()) {
                    setLobbyMode();
                    $(document).trigger('LoggedOut');
                    $(document).trigger('bannersReady');
                    $(document).trigger('gamesReady');
                    document.dispatchEvent(new Event('AsgRenderCarousel'));
                } else if (!$('#home-banner .regulation-txt').length) {
                    $('#home-banner').prepend($('.regulation-txt')[0].outerHTML);
                }
                evt.preventDefault();
                if (InGame.isInGame()) {
                    AsgApp.closeGame();
                }
                const categoryName = $(this).attr('class').replace('game-category-', '');
                if (categoryName === 'sport') {
                    window.location.href = $(this).attr('href');
                } else {
                    const notActiveCategoryName = categoryName.replace(' active', '');
                    currentGamesCategory = notActiveCategoryName;
                    const category = parseInt(categoryName, 10);
                    $('.games-categories li a').removeClass('active');
                    $(`.${$(this).attr('class')}`).addClass('active');
                    $(this).addClass('active');
                    setGamesSubCategories(category);
                    gamesSubCategoriesOnClick();
                    ynaHeader.registerStickyEvents();
                    AsgUI.toggleGAEvents();
                    if (sortClicked) {
                        $(`#sub-${subcategory}`).trigger('click');
                    } else {
                        $(`#sub-${Games.getDefaultSubCategory(category)}`).trigger('click');
                    }
                    sortClicked = false;
                }
            } else {
                if (currentTemplate === 'sport-page.php') {
                    $('.game-category-sport').addClass('active');
                }
                return null;
            }
        });
    };

    const gamesSubCategoriesOnClick = function () {
        $('.games-menu-list li').on('click', function () {
            const category = parseInt($('.games-categories li a.active').attr('class').replace('game-category-', ''), 10);
            subcategory = parseInt($(this).attr('id').replace('sub-', ''), 10);
            $('.subcategory-header-container').html(`<h3 id='grid-header'>${$(`#sub-${subcategory} .name`).html()}</h3>`);
            if ($('.games-menu-list').css('position') === 'fixed') {
                $('html, body').animate({
                    scrollTop: 278,
                }, 300);
            }
            if (isHomeTemplate() && isLobbyMode()) {
                gamesBuild(category);
                sortStateUpdate(sortedCategoriesMap[category][subcategory], $gamesSort);
                Games.hideSortForRecents($(this).find('a')[0].childNodes[0].nodeValue.trim());
            }
            $('.games-menu-list li').removeClass('active');
            $(this).addClass('active');
            if (window.AsgSharedComponents && category === 0) {
                window.AsgSharedComponents.renderJackpots();
            }
            Games.liveCasinoRefresh();
        });
    };

    const gamesBuild = function (category) {
        gamesOpened = 0;
        // eslint-disable-next-line no-param-reassign
        category = Number.isInteger(category) ? category : Games.getDefaultCategory();
        const games = Games.getCategoryGamesWeb(category, subcategory);
        const gamesObj = createGamesHtml(games, true);
        const topGamesContainer = $('.games-grid');
        const regulation = AsgApp.setRegulationTermsParams('com');
        const gamesBanner = `<div class="game-item big-game">
                                <div class="game-item-holder">
                                    <div>
                                        <div class="regulation-txt"><a href="${regulation.link}">${regulation.text}</a></div>
                                        <div class="game-image" data-action="showDeposit"><img src="${AsgApp.getUniversalImagesUri()}web-elements/spinner_small2.gif" alt="IMAGE ALT"/></div>
                                    </div>
                                </div>
                            </div>`;

        const totalGamesObj = gamesObj.top + gamesObj.bottom;
        const winnersTickerData = $('#winners-ticker');
        const showWinnerTicker = AsgFW.getRbcSettings('showWinnerTicker');

        topGamesContainer.html(gamesBanner + totalGamesObj).promise().done(function () {
            Yna.asgApp.components.gamesGrid.refreshGrid();
            AsgApp.setActionEvents('.game-item');
            setGameBanner();
            checkAndHideDemoGame(games);
            if (isLobbyMode() && showWinnerTicker) {
                $(winnersTickerData).insertBefore('.game-item.big-game');
                AsgApp.setActionEvents('.winners-ticker-list .winners-ticker-item');
            }
            Tools.track('gamesGridRendered');
            Tools.log('Games grid has been generated.', null);
        });
    };

    const moreGame = function () {
        $('.more-games-button').on('click', function () {
            const $activeCategory = $('.games-categories li a.active');
            if (!$activeCategory.length) return;
            const category = parseInt($activeCategory.attr('class').replace('game-category-', ''), 10);
            if (!AsgFW.isMobilePamPlatform()) {
                subcategory = parseInt($('.games-menu-list li.active').attr('id').replace('sub-', ''), 10);
            }
            gamesAdd(category, subcategory);
            Yna.asgApp.components.gamesGrid.refreshGrid();
            Games.liveCasinoRefresh();
            if (window.AsgSharedComponents && category === 0) {
                window.AsgSharedComponents.renderJackpots();
            }
        });
    };

    const gamesAdd = function (category, subcategory) {
        const games = Games.getCategoryGamesWeb(category, subcategory);
        $('.close-games').hide();
        const gamesObj = createGamesHtml(games);
        const gamesContainer = $('.games-grid');
        gamesContainer.append(gamesObj.bottom);
        //   loadImages();
        Yna.asgApp.components.gamesGrid.refreshGrid();
        AsgApp.setActionEvents('.game-item');
        checkAndHideDemoGame(games);
    };

    const checkAndHideDemoGame = function (games) {
        // eslint-disable-next-line guard-for-in
        for (const i in games) {
            const game = Games.getGameDetails(games[i]);
            if (game && Games.isNoDemoGame(game.id)) {
                $(`#id-${game.id}`).hide();
            }
        }
    };

    const createGamesHtml = function (games, topGamesFlag) {
        const topGamesHtml = '';
        const gamesHtml = '';
        const gamesObj = { top: topGamesHtml, bottom: gamesHtml };
        let singleGameHtml = '';
        const colmd = 0;
        const topGamesNumber = 11;
        let counter = 0;
        let noDemoFlag = 0;
        const gamesLimit = 59;
        const allowedFlags = ['new', 'vip'];
        if (Player.isLoggedIn()) {
            noDemoFlag = 1;
        }

        let gameIndex = 0;
        // eslint-disable-next-line guard-for-in
        for (const i in games) {
            const game = Games.getGameDetails(games[i]);
            if (game) {
                if (AsgFW.isHideNetentGames() && game.externalGameProvider === 'NetEnt') {
                    continue;
                }

                singleGameHtml = Games.generateGameItem(game.id, game.name, game.images.default, game.images.webp, colmd, noDemoFlag, '', '', '', game.externalGameProvider, game.externalGameSubProvider);
                const singleGameHtmlColmd4 = Games.generateGameItem(game.id, game.name, game.images.default, game.images.webp, 4, noDemoFlag, '', '', '', game.externalGameProvider, game.externalGameSubProvider);
                if (game.gameConfig[0] != null) {
                    const flagStatus = game.gameConfig[0];
                    if (allowedFlags.indexOf(flagStatus.toLowerCase()) > -1) {
                        singleGameHtml = Tools.replaceAll(singleGameHtml, 'status-flag">', `status-flag ${flagStatus.toLowerCase()} ${AsgApp.getLng().toLowerCase()}">`);
                    }
                }

                singleGameHtml = AsgUI.filterDemoButtons(singleGameHtml, game);

                if (topGamesFlag === true) {
                    if (AsgFW.isMobilePamPlatform() && AsgApp.isDoubleGameSize()) {
                        gameIndex += 1;

                        if (gameIndex === 5) {
                            singleGameHtml = Tools.replaceAll(singleGameHtmlColmd4, '[extra-style]', 'data-screen-width="full"');
                            setTopGameStyle(singleGameHtml, gamesObj, counter, topGamesNumber);
                            gameIndex = 0;
                        } else {
                            setTopGameStyle(singleGameHtml, gamesObj, counter, topGamesNumber);
                        }
                    } else {
                        setTopGameStyle(singleGameHtml, gamesObj, counter, topGamesNumber);
                    }

                    counter += 1;
                    if (counter >= gamesLimit) {
                        break;
                    }
                } else {
                    counter += 1;
                    if (counter <= gamesOpened) {
                        continue;
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (AsgFW.isMobilePamPlatform() && AsgApp.isDoubleGameSize()) {
                            gameIndex += 1;

                            if (gameIndex === 5) {
                                singleGameHtml = Tools.replaceAll(singleGameHtmlColmd4, '[extra-style]', 'data-screen-width="full"');
                                gamesObj.bottom += Tools.replaceAll(singleGameHtml, '[extraclass-game]', '');
                                gameIndex = 0;
                            } else {
                                gamesObj.bottom += Tools.replaceAll(singleGameHtml, '[extraclass-game]', '');
                            }
                        } else {
                            gamesObj.bottom += Tools.replaceAll(singleGameHtml, '[extraclass-game]', '');
                        }
                    }
                    if (counter >= gamesLimit + gamesOpened) {
                        break;
                    }
                }
            }
        }
        if (counter < gamesLimit) {
            $('.close-games').hide();
            gamesOpened = counter;
        } else if (counter < gamesOpened + gamesLimit || counter === games.length) {
            $('.close-games').hide();
            gamesOpened += counter;
        } else {
            gamesOpened += gamesLimit;
            $('.games-more-container.log-out').show();
            $('.close-games').show();
        }

        return gamesObj;
    };

    const gamesSearchInit = function () {
        const gameSearch = $('.search-game input');
        const recentTitle = $('.recent');
        let gameSearchHtml;
        gameSearch.on('keyup', function () {
            const searchVal = $(this).val();
            if (searchVal.length > 0) {
                recentTitle.hide();
                gameSearchHtml = Games.searchGameByName(searchVal, false, true, false, false);
                const $gameSearchHtml = $(gameSearchHtml);
                const gameSearchHtmlDemoFixed = $(gameSearchHtml).find('.game-item-holder').each(function () {
                    const gid = $(this).data('gid');
                    const gameParams = Games.getGameById(parseInt(gid, 10));
                    this.innerHTML = AsgUI.filterDemoButtons(this.innerHTML, gameParams);
                });
                $gameSearchHtml.find('.game-item-holder').each(function (i) {
                    this.innerHTML = gameSearchHtmlDemoFixed[i].innerHTML;
                });
                gamesSearchBuild($(this).parents('.search-game').find('.games-list'), $gameSearchHtml);
            } else {
                recentTitle.hide();
                addRecentlyPlayedGamesToGrid();
            }
            $('.search-game .play-for-fun-button').each(function () {
                const gameId = parseInt($(this).attr('id').replace('search_game_id_d_', ''), 10);
                if (Games.isNoDemoGame(gameId)) {
                    $(`#search_game_id_d_${gameId}`).hide();
                }
            });
        });
    };

    const setTickerGamesData = function () {
        const items = $('.winners-ticker-list .winners-ticker-item');
        const actionEventSelector = '.item-holder';
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < items.length; i++) {
            const gameNameElm = $(items[i]).find('.win-details');
            const gameName = gameNameElm.find('.game-name').text().trim();
            const gameObj = Games.getGameByName(gameName);
            const btn = $(items[i]).find('.play-game-btn');
            const actionEventElement = $(items[i]).find(actionEventSelector);
            if (gameObj != null && AsgUI.isFilterNotPresentGames(gameObj.id)) {
                $(items[i]).find('source[type="image/webp"]').attr('srcset', gameObj.images.webp);
                $(items[i]).find('img').attr('src', gameObj.images.default);
                const attr = actionEventElement.data('actionInfo').replace('[gid]', parseInt(gameObj.id, 10));
                actionEventElement.data('actionInfo', attr);
                actionEventElement.attr('data-action-info', attr);
                $(items[i]).find('.winner-content .winner-game-name').data('actionInfo', attr);
                $(items[i]).find('img').data('actionInfo', attr);
                // replace fields for the play button
                if (btn.length) {
                    btn.val(Dictionary.translate('playNow'));
                    btn.attr('data-action-info', attr);
                    const evLab = `click ${gameName} ${AsgApp.getUserStatusText()} login`;
                    $(items[i]).find('.wrap').attr('data-ga-label', evLab);
                }
            } else {
                $(items[i]).remove();
            }
        }
        $(document).trigger('winnersTickerReady');
        AsgApp.setActionEvents('.play-game-btn, .item-holder');
    };

    const specialBenefits = function () {
        const allPanels = (AsgApp.isBrandDK()) ? $('.special-benefits-accordion > .accordion-dd').show() : $('.special-benefits-accordion > .accordion-dd').hide();
        $('.special-benefits-accordion > .accordion-dt > a').on('click', function () {
            if ($(this).parent().next().is(':visible')) {
                allPanels.slideUp();
            } else {
                allPanels.slideUp();
                $(this).parent().next().slideDown();
            }
            return false;
        });
    };

    const setGameBanner = function () {
        const bannerSpecial = AsgApp.getBannersSpecial();
        if (Player.isLoggedIn()) {
            if (bannerSpecial != null) {
                jQuery('.big-game img').attr('src', bannerSpecial.Source);
                AsgApp.setActionEvents('.big-game');
            }
        } else {
            jQuery('.big-game img').attr('src', getBannerSpecialPrelogin());
        }

        if (AsgFW.isMobilePamPlatform()) {
            $('.game-item.big-game').hide();
        }
    };

    const getBannerSpecialPrelogin = function () {
        return appData.specialEventPreloginBanner;
    };

    const setMainBanners = function () {
        const bannersWeb = AsgApp.getBannersWeb();
        const bannersArr = (
            isLobbyMode()
            && !AsgFW.isMobilePamPlatform()
            && appData.lobbyPreloginBanners.length > 0
        )
            ? appData.lobbyPreloginBanners
            : appData.mainBanners;
        let htmlBanners = '';
        if (Player.isLoggedIn()) {
            if (bannersWeb) {
                if (bannersWeb.length === 1 && AsgFW.isMobilePamPlatform()) {
                    htmlBanners += `<div data-action="showDeposit" class="item"><img class="image" src="${bannersWeb[0].Source}" style="padding-bottom: 0;"></div>`;
                } else {
                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < bannersWeb.length; i++) {
                        htmlBanners += getBannerItemTemplate(bannersWeb[i].Source);
                    }
                }
                if (AsgFW.isMobilePamPlatform()) {
                    $('#mobile-banners').html(htmlBanners);
                } else {
                    $('#desc-banners').html(htmlBanners);
                }
            }
        } else if (bannersArr) {
            if (bannersArr.length === 1 && AsgFW.isMobilePamPlatform()) {
                htmlBanners += `<div data-action="showDeposit" class="item"><img class="image" src="${bannersArr[0].url}" style="padding-bottom: 0;"></div>`;
            } else {
                bannersArr.forEach(function (element) {
                    htmlBanners += getBannerItemTemplate(element);
                });
            }
            if (AsgFW.isMobilePamPlatform()) {
                $('#mobile-banners').html(htmlBanners);
            } else {
                $('#desc-banners').html(htmlBanners);
            }
        }
        if (isLobbyMode()) {
            $('#banners').addClass('post-login');
        } else {
            $('#banners').removeClass('post-login');
        }
        AsgApp.setActionEvents('#banners');
    };

    const stopGameMode = function () {
        if (!InGame.isPassTroughGame()) {
            $('body').removeClass('game-mode-active');
            if (AsgFW.isMobilePamPlatform()
                || !AsgApp.isGamePageTemplate()
            ) {
                $('#in-game-container').removeClass('is-active');
            }
            if (isGamePage()) {
                $('.wrap').css('padding-top', '76px');
            }
        }
    };

    const startGameMode = function () {
        if (!isGamePage() || (isGamePage() && AsgFW.isMobilePamPlatform())) {
            $('body').addClass('game-mode-active');
        }
        $('#in-game-container').addClass('is-active');
    };

    const setDisplayBalance = function () {
        const balance = AsgApp.getDisplayBalance().DisplayBalance;
        $('.sum-span').text(balance);
    };

    const setLoyaltyPoints = function () {
        const obj = AsgApp.getLoyaltyPoints();
        const percents = obj.ProgressPercentForNextLevel;

        if (obj.PointsForNextLevel <= -1) {
            $('#reward-percent').hide();
            $('.points').hide();
            $('.stars').css('margin-top', '10px');
        } else {
            $('.reward-percent').text(`${percents}%`).css('width', `${parseInt(percents, 10)}%`);
            $('.points').show();
            $('.stars').css('margin-top', '0');
        }

        $('.reward-title').text(obj.LoyaltyLevelName);
        $('.rewards-stars-div').addClass(`stars-${obj.CurrentLevelNumber}`);
        $('.reward-sign').addClass(`img-span-${obj.CurrentLevelNumber}`);
    };

    const menuTitleUpdate = function () {
        const obj = ng_fw.getSessionDetails();
        if (Object.prototype.hasOwnProperty.call(obj, 'PlayerName')) {
            // Fill web menu
            $('#account_details li a').first().text(obj.PlayerName);
            // Fill New Sidebar menu
            AsgUI.NSBMenu.fillPostLoginData();
        }
    };

    const getOldHomeTemplate = function (tml) {
        if (tml === 'template-home.php' || tml === 'template-lobby.php') {
            return 'page.php';
        }
        return tml;
    };

    const getCurrentCategory = function () {
        return currentGamesCategory;
    };

    const getBannerItemTemplate = function (item) {
        const imgUrl = Object.prototype.hasOwnProperty.call(item, 'url') ? item.url : item;
        const link = Object.prototype.hasOwnProperty.call(item, 'description') ? item.description : '';
        const action = link === '' ? 'showDeposit' : 'navigateTo';
        return `<div data-action="${action}" data-action-info="${link}" class="item"><div class="image" style="cursor: pointer; background-image: url(${imgUrl})"></div></div>`;
    };

    const setTopGameStyle = function (singleGameHtml, gamesObj, counter, topGamesNumber) {
        if (counter < topGamesNumber) {
            if (counter > 10) {
                // eslint-disable-next-line no-param-reassign
                gamesObj.bottom += Tools.replaceAll(singleGameHtml, '[extraclass-game]', 'no-show-lg');
                // eslint-disable-next-line no-param-reassign
                singleGameHtml = Tools.replaceAll(singleGameHtml, '[extraclass-game]', 'show-lg');
            }
            // eslint-disable-next-line no-param-reassign
            gamesObj.top += Tools.replaceAll(singleGameHtml, '[extraclass-game]', '');
        } else {
            // eslint-disable-next-line no-param-reassign
            gamesObj.bottom += Tools.replaceAll(singleGameHtml, '[extraclass-game]', '');
        }
    };

    const gamesSearchBuild = function (gamesListDiv, html) {
        gamesListDiv.show();
        gamesListDiv.empty();
        gamesListDiv.append(html);
        replaceSearchImage();
        AsgApp.setActionEvents('.search-game');
    };

    const replaceSearchImage = function () {
        const items = $('.search-game .game-item').find('img');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < items.length; i++) {
            $(items[i]).attr('src', $(items[i]).data('src'));
        }
    };

    const closeSideMenu = function () {
        $('.slide-menu-container').on('click', '[data-action="showGameSearch"]', function () {
            Yna.asgApp.components.searchForm.showForm();
            // hides the upper menu when the search form opens
            $('.main-menu-mobile').hide();
        });
    };

    const loadMobilePartialsCategory = function () {
        MobilePartialsRequestCategory = $.get(`${themeURI}partials/mobile_game_category.php`, function (data) {
            mobileGameCategory = data;
        });
    };

    const loadMobilePartialsGame = function () {
        MobilePartialsRequestGame = $.get(`${themeURI}partials/game_item.php`, function (data) {
            mobileSingelGame = data;
            mobileSingelGame = Tools.replaceAll(mobileSingelGame, '[theme_dir]', themeURI);
            mobileSingelGame = Tools.replaceAll(mobileSingelGame, '[default_image]', `${themeURI}images/spinner_small.gif`);
        });
    };

    $(document).on('dictionaryReady', function () {
        dictionaryRequest.resolve();
    });

    const replaceDynamicParameterForMobile = function (cat, gamesQuantity) {
        let mobileGameCategoryEdit = mobileGameCategory;

        mobileGameCategoryEdit = Dictionary.translateString(mobileGameCategoryEdit);
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[categorySlug]', cat.name.replaceAll(' ', '_'));
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[categoryName]', cat.name);
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[gamesQuantity]', gamesQuantity);
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[10-games-grid]', mobile10GameGrid(cat.subCategories[0].instantGamesOrder, gamesQuantity));
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[all-games-grid]', mobileAllGameGrid(cat.subCategories[0].instantGamesOrder));
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[extraElement]', cat.extraElement || '');
        mobileGameCategoryEdit = Tools.replaceAll(mobileGameCategoryEdit, '[codeName]', cat.subCategories[0].codeName || '');

        return mobileGameCategoryEdit;
    };

    const mobile10GameGrid = function (allGamesIdForThisMobileCategory, gamesQuantity) {
        let i = 1;
        let html = '';
        const maxGamesToShow = (gamesQuantity < 10 ? gamesQuantity : 20);
        allGamesIdForThisMobileCategory.forEach(function (gameId) {
            if (i <= maxGamesToShow) {
                const gameParams = Games.getGameById(parseInt(gameId, 10));
                let mobileSingelGameEdit = mobileSingelGame;
                if (gameParams) {
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[img]', gameParams.images.default.replace('_1x_', '_3x_'));
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[imgWebp]', gameParams.images.webp.replace('_1x_', '_3x_'));
                    // games demo links
                    const gameSlug = gameParams.name.trim().replace(/[ ]/g, '-').toLowerCase();
                    const subProvider = getGameSubProvider(gameParams);
                    const provider = getGameProvider(gameParams);
                    const demo = gameParams.playModes.includes('Demo') ? '' : 'hide';
                    mobileSingelGameEdit = AsgUI.filterDemoButtons(
                        mobileSingelGameEdit,
                        gameParams,
                    );
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[name]', gameParams.name);
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[demopopup]', demo);
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[name-slug]', gameSlug);
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[gid]', parseInt(gameId, 10));
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[provider]', provider);
                    mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[sub_provider]', subProvider);
                    mobileSingelGameEdit = `<div class='swiper-slide' data-screen-width='portrait'>${mobileSingelGameEdit}</div>`;
                    html += mobileSingelGameEdit;
                    i += 1;
                }
            }
        });
        if (window.AsgSharedComponents) {
            window.AsgSharedComponents.renderJackpots();
        }
        return html;
    };

    /**
     * Gets game params object ( from Games.getGameById(id) ),
     * retrieves sub provider if possible. if not, retrieves provider.
     * @param {object} gameParams
     * @return {string|*}
     */
    const getGameSubProvider = function (gameParams) {
        if (
            Object.prototype.hasOwnProperty.call(gameParams, 'externalGameSubProvider')
            && gameParams.externalGameSubProvider !== ''
        ) {
            return gameParams.externalGameSubProvider.replace(/[ ]/g, '-');
        }
        return gameParams.externalGameProvider.replace(/[ ]/g, '-');
    };

    const getGameProvider = function (gameParams) {
        return gameParams.externalGameProvider.replace(/[ ]/g, '-');
    };

    const mobileAllGameGrid = function (allGamesIdForThisMobileCategory) {
        let html = '';
        allGamesIdForThisMobileCategory.forEach(function (gameId) {
            const gameParams = Games.getGameById(gameId);
            let mobileSingelGameEdit = mobileSingelGame;
            if (gameParams) {
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[img]', gameParams.images.default.replace('_1x_', '_3x_'));
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[imgWebp]', gameParams.images.webp.replace('_1x_', '_3x_'));
                // games demo links
                const gameSlug = gameParams.name.trim().replace(/[ ]/g, '-').toLowerCase();
                const subProvider = getGameSubProvider(gameParams);
                const provider = getGameProvider(gameParams);
                const demo = gameParams.playModes.includes('Demo') ? '' : 'hide';
                mobileSingelGameEdit = AsgUI.filterDemoButtons(
                    mobileSingelGameEdit,
                    gameParams,
                );
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[name]', gameParams.name);
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[name-slug]', gameSlug);
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[demopopup]', demo);
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[gid]', parseInt(gameId, 10));
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[provider]', provider);
                mobileSingelGameEdit = Tools.replaceAll(mobileSingelGameEdit, '[sub_provider]', subProvider);
                if (Games.isNoDemoGame(gameId)) {
                    const res = mobileSingelGameEdit.split(`id-${gameId}`);
                    mobileSingelGameEdit = `${res[0]}id=${gameId}" style="display: none;"${res[1]}`;
                }
                html += mobileSingelGameEdit;
            }
        });
        return html;
    };

    const mobileCategoryGrid = function (categories) {
        const container = $('#mobile-categories-grid');
        container.empty();
        $.when(
            MobilePartialsRequestCategory,
            MobilePartialsRequestGame,
            dictionaryRequest,
        ).done(function () {
            buildMobileCategoryGridAsync(container, categories).then(() => {
                const gamesIdArr = [];
                $('#mobile-categories-grid .game-item .play-for-fun-button').each(function () {
                    const gid = $(this)[0].id;
                    if (gid) {
                        gamesIdArr.push(gid.replace('id-', ''));
                    }
                });
                checkAndHideDemoGame(gamesIdArr);
                setTimeout(ynaMobileHomePage.initScrollbars.bind(ynaMobileHomePage), 5000);
                ynaMobileHomePage.initScrollLazyload();
                AsgApp.setActionEvents('#mobile-categories-grid');
            });
        });
    };

    const buildMobileCategoryGridAsync = function (container, categories) {
        return new Promise(resolve => {
            let categoriesToProcess = categories.length;
            let categoriesProcessed = 0;
            mobileSingelGame = Dictionary.translateString(mobileSingelGame);

            categories.forEach(function (cat) {
                const gamesQuantity = cat.subCategories[0].instantGamesOrder.length;

                if (gamesQuantity > 0) {
                    setTimeout(() => {
                        categoriesProcessed += 1;
                        container.append(replaceDynamicParameterForMobile(cat, gamesQuantity));

                        if (categoriesProcessed === categoriesToProcess) {
                            resolve();
                        }
                    }, 50);
                } else {
                    categoriesToProcess -= 1;
                }
            });
        });
    };

    const loadMainCssAsync = (themeUri) => new Promise((resolve) => {
        if (!Tools.isDebug()) {
            Tools.appendCss(`${themeUri}/app.style.min.webpack.css`);
        }

        resolve();
    });

    let mobileWinnerTickerInit = function () {
        $('.mobile-winner-ticker-wrap').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                    },
                },
            ],
        });
    };

    // eslint-disable-next-line no-extend-native
    String.prototype.replaceAll = function (target, replacement) {
        return this.split(target).join(replacement);
    };

    const setGameIdInPage = function (gameName, gameMode) {
        // eslint-disable-next-line no-param-reassign
        gameMode = gameMode || 'D';

        const gid = Games.getGameByName(gameName).id;
        InGame.setAttributes(null, null, null, 690);
        $('.game-page-load-game').attr('data-action-info', `${gid}|${gameMode}`);

        const img = $('.game-page-load-game.default').find('img');
        if (img) {
            const url = img.attr('src');
            if (url) {
                const temp = url.replaceAll('[gid]', gid);
                img.attr('src', temp);
            }
        }

        AsgApp.setActionEvents('#in-game-container-mobile');
    };

    const loadGameInPage = function (gameName, gameMode) {
        // eslint-disable-next-line no-param-reassign
        gameMode = gameMode || 'D';
        // Hide games for no demo games countries.
        if (AsgApp.isNoDemoGamesCountry() && !Player.isLoggedIn()) {
            return;
        }

        if (Games.getGameByName(gameName)) {
            const gid = Games.getGameByName(gameName).id;
            InGame.setAttributes(null, null, null, null);
            AsgApp.loadGame(`${gid}|${gameMode}|GP`);
        }
    };

    const isGamePage = function () {
        return currentTemplate === 'game-page.php';
    };

    const isInView = function (elem) {
        if ($(elem).offset()) {
            return ($(elem).offset().top - $(window).scrollTop()
                < $(elem).height() + ($(window).height() - 200));
        }
        return false;
    };

    const loadImages = function () {
        $('[data-original]').each(function () {
            const image = $(this)[0];
            const downloadImage = new Image();
            downloadImage.onload = function () {
                image.src = this.src;
            };
            downloadImage.src = $(image).data('original');
        });
    };

    // Panic button - special behaviour for submenu when scrolling or resizing window.
    $(window).on('scroll resize', function () {
        if ($('body').hasClass('panic-pane') && $('.games-categories-search-section').hasClass('is-fixed')) {
            $('body.panic-pane .games-categories-search-section .games-menu-holder').css({ top: `${$('#site-header').find('.navbar').height() + 43}px` });
        }
    });

    $(document).on('loadGame', function () {
        Games.liveCasinoStop();
    });

    /**
     * New Sidebar menu feature.
     */

    $(document).on('asgReady', (() => initNewSideMenu()));

    // New Sidebar menu init.
    const initNewSideMenu = function () {
        // NSB Menu initialization flow:
        addNSBMenuEventHandlers(); // Add all main NSB Menu event handlers and controls.
        AsgUI.NSBMenu.addPromotionsNumber(); // Add promotions number to the menu.
        AsgUI.NSBMenu.setGAEvents(); // Set initial GA events.
        AsgUI.NSBMenu.initSearchPane(); // Init search pane.
    };

    // Add all main NSB Menu event handlers.
    let addNSBMenuEventHandlers = function () {
        // Add events, dependant on Login / Logout events.
        $(document).on('LoggedIn LoggedOut', function () {
            AsgUI.NSBMenu.setGAEvents(); // Set GA events.
        });

        // Handle submenu-parents behaviour
        $('.sb-toggle-submenu').off('click') // Stop submenu toggle from closing Slidebars.
            .on('click', function () {
                const $submenu = $(this).parent().children('.sb-submenu');
                $(this).add($submenu).toggleClass('sb-submenu-active'); // Toggle active class.

                if ($submenu.hasClass('sb-submenu-active')) {
                    $submenu.slideDown(200);
                } else {
                    $submenu.slideUp(200);
                }
            });

        // Handle submenu items behaviour
        $('.sb-menu li').on('click', function () {
            if ($(this).find('.sb-submenu').length === 0) {
                ynaHeader.toggleOffCanvas();
            }
        });

        // Close menu.
        $(document).on('closeNSB', function () {
            ynaHeader.toggleOffCanvas();
        });

        // Refresh Player's information like balance on 'endInGame' and 'balanceUpdated'
        $(document).on('balanceUpdated endInGame', function () {
            AsgUI.NSBMenu.fillPostLoginData();
        });
    };

    /**
     * END New Sidebar menu feature.
     */

    /**
     * @param {HTMLElement} element. Creates an interactive deposit box and injects
     * it into the element of the banner
     * @param {string} location: append or prepend to current element
     */
    const addInteractiveDepositBanner = function (element, location) {
        if (
            !AsgApp.isPayNPlayEnabled()
            || Player.isLoggedIn()
            || !AsgApp.getPayNPlayData().isPayNPlayIntegrationEnabled
        ) {
            return;
        }

        let bannersList = Object.prototype.hasOwnProperty.call(appData, 'interactiveDepositBannersList')
            && appData.interactiveDepositBannersList;
        if (!bannersList.length) return; // If banners array is empty, the feature is disabled
        if (!AsgFW.isMobilePamPlatform()) {
            bannersList = isLobbyMode() ? bannersList[0].lobby : bannersList[0].home;
            if (!bannersList) return;
            bannersList = bannersList.split(',');
        }
        $.ajax(`${AsgApp.getFrameworkUri()}components/interactive-deposit-banner/interactive-deposit-banner.js`, {
            dataType: 'script',
            cache: true,
            success() {
                InteractiveDepositBanner.init(element, location, bannersList);
            },
        });
    };

    /**
     * close WalkThrough by click on panic button
     */
    $('#in-game-container').on('click', '#panic-button-ingame .sb-slider', function () {
        AsgApp.closeWalkThroughIfOpen();
    });

    /**
     * set game link by game id
     * @param el
     */
    const setGameLink = (el) => {
        const gameName = Games.getGameNameById(el.data('id'));
        if (gameName) {
            el.attr('href', gameNameToUrl(gameName));
        } else {
            el.removeAttr('href');
        }
    };

    /**
     * get game path by game name
     * @param gameName
     * @returns {`/casino/games/${string}/`}
     */
    const gameNameToUrl = (gameName) => {
        const name = gameName.trim().replace(/[ ]/g, '-').toLowerCase();
        return `/casino/games/${name}/`;
    };

    /**
     * replace game href
     * from /casino/games/[game_name]]
     * to /casino/games/xxxxxx]
     * if game not exist ig game list remove href
     */
    const setGameLinkByIdOnLobbyPage = () => {
        const elements = $('.first-home-games-grid .actions a');
        if (elements.length > 0) {
            elements.each(function () {
                const el = $(this);
                if (el.attr('href') !== undefined) {
                    setGameLink(el);
                }
            });
        }
    };

    const setNewGamePagePreferences = () => {
        if (AsgFW.isMobilePamPlatform()) {
            const $bannerElement = $('.mobile-play-for-real-banner:not(.sticky-mobile-play-for-real-banner)');
            $(document).on('scroll', () => {
                const scrollTop = $(document).scrollTop();
                const topDistance = $bannerElement.offset().top - $('.container-fluid').height();
                if (scrollTop >= topDistance) {
                    $bannerElement.addClass('fixed');
                    $('.sticky-mobile-play-for-real-banner').addClass('fixed');
                } else {
                    $bannerElement.removeClass('fixed');
                    $('.sticky-mobile-play-for-real-banner').removeClass('fixed');
                }
            });
        }
    };
    return {
        init,
        moreGame,
        gamesBuild,
        setPlayerLobbyBanners,
        addInteractiveDepositBanner,
        loadMainCssAsync,
        getCurrentCategory,
    };
})();

/*** EXPORTS FROM exports-loader ***/
export {
  AppUI
};
